import { RegionsResponse } from "../types/types";
import { API_URL } from "../utils/config";

export const getRegions = (): Promise<RegionsResponse> => {
  return fetch(`${API_URL}/regions`).then((response) => {
    return response.json();
  });
};
